module.exports = __webpack_public_path__ + "img/madera01.059da17a.jpg";